
const firebaseConfig = {
  apiKey: "AIzaSyDRZgaR5qZxHNns9buanfD593QJCGYS_g4",
  authDomain: "georef-training.firebaseapp.com",
  projectId: "georef-training",
  storageBucket: "georef-training.appspot.com",
  messagingSenderId: "746135431146",
  databaseURL: "https://georef-training-default-rtdb.europe-west1.firebasedatabase.app",
  appId: "1:746135431146:web:95feb56b129001417a3493"
};

export default firebaseConfig